import "react-bootstrap-table-next/dist/react-bootstrap-table2.min.css";
import "react-bootstrap-table2-toolkit/dist/react-bootstrap-table2-toolkit.min.css";

import BootstrapTable from "react-bootstrap-table-next";
import paginationFactory from "react-bootstrap-table2-paginator";
import ToolkitProvider, {
  Search,
} from "react-bootstrap-table2-toolkit/dist/react-bootstrap-table2-toolkit";
import { useState } from "react";
import DataTableBOM from "./DataTableBOM";
import DataTableOperations from './DataTableOperations';



const DataTableComponentsPO=(listComponents)=>{
    console.log("listProduits", listComponents.listComponents);
    const [openInfoAlert, setOpenInfoAlert] = useState(false);
  
    const { SearchBar } = Search;
   
  
    function nameFormatter(cell, row) {
      if (row.facture !== null) {
        return (
          <span>
            {row.facture.supplier.matricule}-{row.facture.supplier.title}
          </span>
        );
      } else if (row.purchaseOrder !== null) {
        return (
          <span>
            {row.purchaseOrder.supplier.matricule}-
            {row.purchaseOrder.supplier.title}
          </span>
        );
      }
    }
    function finalPriceFormatter(cell, row) {
      if (row.facture !== null) {
        if (row.facture.finalPriceTt !== null) {
          return <span>{row.facture.finalPriceTt}</span>;
        } else {
          return <span>{row.facture.priceTT}</span>;
        }
      } else if (row.purchaseOrder !== null) {
        return <span>{row.purchaseOrder.priceTT}</span>;
      }
    }
    function refFormatter(cell, row) {
      console.log("row", row);
   
        return <span>{row.product.productCode}-{row.product.name}</span>;
    
    }
    function titleFormatter(cell, row) {
      
        return <span>{row.unitOfMeasure.code}-{row.unitOfMeasure.name}</span>;
     
    }
  
    const columns = [
      {
        dataField: "id",
        text: "Réf",
        headerAlign: "center",
        formatter: refFormatter,
      },
  
      {
        dataField: "product.id",
        text: "Titre",
        align: "center",
        headerAlign: "center",
        formatter: titleFormatter,
  
        headerStyle: () => {
          return { width: "15%" };
        },
      },
     
      {
        dataField: "quantity",
        text: "quantity",
        align: "center",
        headerAlign: "center",
        // formatter: finalPriceFormatter,
  
        headerStyle: () => {
          return { width: "15%" };
        },
      },
    ];
   
   
    function buttonFormatter(element, refFacture) {
      if (element.path !== null) {
        return (
          <span>
            {/* <a
              // style={{ color: blue }}
              class="btn btn-success btn-sm "
              onClick={() =>
                onShowFileInOtherWindowHandler(
                  UtilsUrl.fileRetailURL() + element.path
                )
              }
            >
              Référence : {element.uniqueId}
            </a> */}
            <p></p>
          </span>
        );
      } else {
        return (
          <span>
            {/* <a
              // style={{ color: blue }}
              class="btn btn-warning btn-sm "
              onClick={() => onUploadFileHandler(element.uniqueId, refFacture)}
            >
              Référence : {element.uniqueId}
            </a> */}
            <p></p>
          </span>
        );
      }
    }
  
    const rates = (element) => {
      if (element.productPurchaseHistories.length !== 0) {
        console.log("productPurchaseHistories", element.productPurchaseHistories);
        return (
          <div class="col-md-12">
            <div class="card card-dark collapsed-card">
              <div class="card-header">
                <h3 class="card-title">Les opérations de réception</h3>
                <div class="card-tools">
                  <button
                    type="button"
                    class="btn btn-tool"
                    data-card-widget="collapse"
                  >
                    <i class="fas fa-plus"></i>
                  </button>
                </div>
              </div>
  
              <div class="card-body">
                {/* {listRates(element.productPurchaseHistories)} */}
              </div>
            </div>
          </div>
        );
      }
    };
   
    function typeFormatter(type) {
      if (type === 1) {
        return <span className="badge bg-success">Nouvel arrivage</span>;
      } else if (type === 2) {
        return <span className="badge bg-warning">Refusé</span>;
      } else if (type === 3) {
        return <span className="badge bg-primary">Arrivage du retours</span>;
      }
    }
  
    const importProduct = (row) => {
      console.log("importProduct",row.boms)
      return (
        <div>
          <label>{row.boms.code}</label>
          <br/>
          <label>{row.product.productCode}-{row.product.name}</label>
          <br/>
          <label>{row.boms.quantity} {" "}{row.boms.unitOfMeasure.code}-{row.boms.unitOfMeasure.name}</label>
          <br/>
          <label>Les composants</label>
          <DataTableBOM listBOM={row.boms.componentList}/>
          {row.boms?.dechetList!=null && <><label>Les déchets</label>
          <DataTableBOM listBOM={row.boms.dechetList}/></>
        } 

          <label>Les opérations</label>
          <DataTableOperations listOperation={row.boms.operations}/>
          {/* {row.transactionOperations &&
            row.transactionOperations.map((element, i) => (
              <div className="row">
                {" "}
                <div class="col-md-12">
                  {row.facture !== null &&
                    buttonFormatter(element, row.facture.ref)}
                  {row.purchaseOrder !== null &&
                    buttonFormatter(element, row.purchaseOrder.ref)}
                  
                </div>
                {rates(element)}
              </div>
            ))} */}
        </div>
      );
    };
    const expandRow = {
      renderer: (row) => importProduct(row),
      showExpandColumn: true,
      expandByColumnOnly: true,
      expandHeaderColumnRenderer: ({ isAnyExpands }) => {
        if (isAnyExpands) {
          return <b>-</b>;
        }
        return <b>+</b>;
      },
      expandColumnRenderer: ({ expanded }) => {
        if (expanded) {
          return <b>-</b>;
        }
        return <b>+</b>;
      },
    };
  
    const handleInfoClose = (event, reason) => {
      if (reason === "clickaway") {
        return;
      }
      setOpenInfoAlert(false);
    };
  
    function handleTableChange({ products }) {
      return products;
    }
    const pageButtonRenderer = ({
      page,
      active,
      disable,
      title,
      onPageChange,
    }) => {
      const handleClick = (e) => {
        e.preventDefault();
        onPageChange(page);
      };
      const activeStyle = {};
      if (active) {
        activeStyle.backgroundColor = "black";
        activeStyle.color = "white";
      } else {
        activeStyle.backgroundColor = "white";
        activeStyle.color = "black";
      }
      if (typeof page === "string") {
        activeStyle.backgroundColor = "white";
        activeStyle.color = "black";
      }
      return (
        <li className="page-item">
          <button
            className="btn btn-dark"
            onClick={handleClick}
            style={activeStyle}
          >
            {page}
          </button>
        </li>
      );
    };
    const options = {
      pageButtonRenderer,
    };
  
    return (
     
          <ToolkitProvider
            keyField="id"
            data={listComponents.listComponents}
            columns={columns}
            // exportCSV
          >
            {(props) => (
              <div>
                <div className="row ml-0">
                  <div>
                    <SearchBar
                      {...props.searchProps}
                      className="custome-search-field"
                      style={{ color: "black" }}
                      placeholder="Chercher"
                    ></SearchBar>
                  </div>
                </div>
                <div className="row">
                  <BootstrapTable
                    {...props.baseProps}
                    pagination={paginationFactory(options)}
                    striped
                    hover
                    condensed
                    expandRow={expandRow}
                  />
                </div>
              </div>
            )}
          </ToolkitProvider>
      
    );
}

export default DataTableComponentsPO;